import type { EditProfileFormSchema } from '@/modules/profile/components/EditProfileForm/EditProfileForm.types'

import type { UserData } from '@/__generated__/requests'

export function editProfileFormDefaultValues(
  user: UserData | null,
): EditProfileFormSchema {
  return {
    avatar: user?.avatar,
    bio: user?.bio || null,
    email: user?.email || '',
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    personalEmail: user?.personalEmail,
    phone: user?.phone,
  }
}
